import create from 'zustand';
import shallow from 'zustand/shallow';
import type { Banner } from '@hotjar/hotsauce';
import type { ReactElement } from 'react';

export type StickyBannerProps = {
  isDismissible?: boolean | undefined;
  kind: React.ComponentProps<typeof Banner>['kind'];
  actionText?: string | undefined;
  actionHref?: string | undefined;
  actionProps?: React.ComponentProps<typeof Banner>['actionProps'] | undefined;
  onAction?: React.ComponentProps<typeof Banner>['onAction'] | undefined;
  text: string | ReactElement;
  onDismiss?: React.ComponentProps<typeof Banner>['onDismiss'] | undefined;
};

type StickyNotificationsState = {
  notifications: Record<string, StickyBannerProps | undefined>;
  isVisible: (notificationInstance: string) => boolean;
  show: (notificationInstance: string, params: StickyBannerProps) => void;
  hide: (notificationInstance: string) => void;
};

export const useStickyNotificationStore = create<StickyNotificationsState>((set, get) => ({
  notifications: {},
  isVisible: (notificationInstance: string) => !!get().notifications[notificationInstance],
  show: (notificationInstance: string, params: StickyBannerProps) =>
    set((state) => ({
      notifications: { ...state.notifications, [notificationInstance]: { ...params } },
    })),
  hide: (notificationInstance) =>
    set((state) => {
      const tempState = { notifications: state.notifications };
      delete tempState.notifications[notificationInstance];
      return tempState;
    }),
}));

export const useStickyNotification = (): StickyNotificationsState =>
  useStickyNotificationStore((state) => state, shallow);
